<div
	class="wrapper"
	(click)="clicked()"
	[class.sortable]="!!property"
	[class.desc]="sortDirection === 'desc'"
	[class.asc]="sortDirection === 'asc'"
>
	<ng-content></ng-content>
	<span *ngIf="!hideSorting" class="sort">
		<i class="fas fa-stack-1x fa-sort-up"></i>
		<i class="fas fa-stack-1x fa-sort-down"></i>
	</span>
</div>
